// extracted by mini-css-extract-plugin
module.exports = {"box":"ChapterBox_box__7fQwI","disabled":"ChapterBox_disabled__pmG08"};